import React, {useEffect, useState} from "react";
import { Dropdown } from 'primereact/dropdown';

export default function NSSelectAutocomplete({
                                                 startVal,
                                                 formikRef = null,
                                                 name,
                                                 placeholder = '',
                                                 options = [],
                                                 onChangeSelect = () => {
                                                 },
                                                 isDisabled = false,
                                                 invalid = false,
                                                 valueTemplate = null,
                                                 itemTemplate = null,
                                                 isInModal
                                             }) {

    const [valore, setValore] = useState();
    const [values, setValues] = useState([]);

    useEffect(() => {
        if (options) {
            let opts = Array.isArray(options) ? options : options();
            opts = opts.map((o) => {
                let newO = {};
                newO.name = o.label;
                newO.code = o.value.toString();
                return newO;
            })
            setValues(opts);

            let valoreSelezionato = opts && opts.filter(o => o.code == startVal);
            setValore(valoreSelezionato && valoreSelezionato.length > 0 ? valoreSelezionato[0] : null);
        }
    }, [options, startVal]);

    return options && (
        <Dropdown
        name={name}
        value={valore} 
        onChange={(e) => {
            let newVal = e.value;
            if (!newVal) {
                newVal = {
                    code: ''
                }
            }
            if (formikRef) {
                formikRef.current.setFieldValue(name, newVal.code)
            }

            setValore(newVal)
            onChangeSelect(newVal);
        }} 
        className="w-100"
        options={values} 
        optionLabel="name" 
        placeholder={placeholder}
        valueTemplate={valueTemplate} 
        itemTemplate={itemTemplate}
        disabled={isDisabled}
        showClear 
        filter={values && values.length > 10 ? true : undefined}
        filterInputAutoFocus
        invalid={invalid}
        panelClassName={isInModal ? "ns-modal-select" : ''}
        emptyMessage={"Nessun dato presente"}
        />
    )
}